const SeparatorBottom = () => (
  <div className="transition-all duration-500 h-[100px] md:h-[200px]">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="transition duration-500 bg-gray-100 fill-gray-200 dark:fill-gray-700 dark:bg-gray-800 w-[100vw] h-[100%]">
      <path d="M0.00,49.98 C149.99,150.00 271.49,-49.98 500.00,49.98 L500.00,0.00 L0.00,0.00 Z" />
    </svg>
  </div>
);

export default SeparatorBottom;
